import { FC } from "react";

import { ProgressOverlay } from "@framework/mui-page-layout";
import { RangeType, useAsu } from "@framework/provider-asu";

import { getSelectedItemType, SELECTED_ITEM_TYPE } from "../../../../utils";
import { StationScheme } from "./views/station-scheme";
import { TrainScheme } from "./views/train-scheme";
import { Wrapper } from "./styled";

export const Scheme: FC = () => {
  const { isLoading, selectedItem, userSelectedRangeType } = useAsu();

  const isStationSelected = getSelectedItemType(selectedItem) === SELECTED_ITEM_TYPE.station;

  return (
    <ProgressOverlay
      isLoading={isLoading && userSelectedRangeType !== RangeType.RECORDER_MODE}
      wrapperSx={{ height: "100%", minHeight: 0 }}
    >
      <Wrapper>{isStationSelected ? <StationScheme /> : <TrainScheme />}</Wrapper>
    </ProgressOverlay>
  );
};
